import EntityModel from '@/common/models/entity-model';
import ContactPhoneEmailItemsModel from '@/common/models/contact-phone-email-items-model';
import timezones from '@/data/timezones';

export default class OrganizationModel extends EntityModel {
    hydrate({
        id = null,
        name = null,
        address = null,
        address2 = null,
        city = null,
        country = null,
        region = null,
        postalCode = null,
        phoneNumbers = null,
        emails = null,
        taxDescriptor = null,
        isPrimary = false,
        invoiceTimeZone = timezones.default,
        createdTime = null,
        updatedTime = null,
    } = {}) {
        this.id = id;
        this.name = name;
        this.address = address;
        this.address2 = address2;
        this.city = city;
        this.country = country;
        this.region = region;
        this.postalCode = postalCode;
        this.phoneNumbers = (phoneNumbers || []).map(
            phoneNumber => new ContactPhoneEmailItemsModel(phoneNumber),
        );
        this.emails = (emails || []).map(
            email => new ContactPhoneEmailItemsModel(email),
        );
        this.taxDescriptor = taxDescriptor;
        this.isPrimary = isPrimary;
        this.invoiceTimeZone = invoiceTimeZone;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
    }

    getPayload() {
        const payload = {
            id: this.id,
            name: this.name,
            address: this.address,
            address2: this.address2,
            city: this.city,
            country: this.country,
            region: this.region,
            postalCode: this.postalCode,
            phoneNumbers: this.phoneNumbers,
            emails: this.emails,
            taxDescriptor: this.taxDescriptor,
            invoiceTimeZone: this.invoiceTimeZone,
        };
        if (this.isPrimary) {
            payload.isPrimary = this.isPrimary;
        }
        return payload;
    }
}
